<template>
    <div class="pagination-state">
        <p>
            <template v-if="pagination.page_count > 1">
                <span>{{ productsCount[0] }} - {{ productsCount[1] }}</span> z
            </template>
            {{ pagination.product_found }} produktów
        </p>
    </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
    name: 'CatalogPaginationState',
    computed: {
        ...mapState(['pagination']),
        ...mapState({
            currentPage: (state) => Number(state.params.p),
            resultsPP: (state) => Number(state.params.resultsPP)
        }),
        productsCount() {
            let from = 1
            let to = this.resultsPP * 1
            if (this.currentPage > 1) {
                from = (this.currentPage - 1) * this.resultsPP + 1
                to = this.currentPage * this.resultsPP + 1

                if (this.pagination.product_found < to) {
                    to = this.pagination.product_found
                }
            }
            return [from, to]
        }
    }
}
</script>
<style lang="scss">
.pagination-state {
    @include n-theme() {
        color: theme(color-secondary);
    }

    p {
        margin: 0;
        font-size: 16px;

        span {
            color: $sherpa-blue;
            font-weight: 600;
        }
    }
}
</style>
